/// <amd-module name="SuiteCommerce.CookieConsent.CookieConsentLinkCCT.CookieConsentCCT.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.CookieConsentLinkCCT.CookieConsentCCT.View", ["require", "exports", "suitecommerce_cookie_consent_cct_template.tpl", "CustomContentType.Base.View"], function (require, exports, CookieConsentCCTTemplate, CustomContentTypeBaseView) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CookieConsentCCTView = void 0;
    var CookieConsentCCTView = /** @class */ (function (_super) {
        __extends(CookieConsentCCTView, _super);
        function CookieConsentCCTView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = CookieConsentCCTTemplate;
            _this.events = {
                'click [data-action="openCookieSettingsLink"]': 'openCookieSettings'
            };
            return _this;
        }
        CookieConsentCCTView.prototype.openCookieSettings = function () {
            this.showBackDrop();
            jQuery('#cookieconsentModal').modal({
                backdrop: false,
                keyboard: false,
                focus: true
            });
        };
        CookieConsentCCTView.prototype.showBackDrop = function () {
            jQuery('#cookieConsentBackdrop').removeClass('hide');
        };
        CookieConsentCCTView.prototype.install = function (settings, contextData) {
            _super.prototype.install.call(this, settings, contextData);
            this.settings = settings;
            return jQuery.Deferred().resolve();
        };
        CookieConsentCCTView.prototype.update = function (settings) {
            _super.prototype.update.call(this, settings);
            this.settings = settings;
            return jQuery.Deferred().resolve();
        };
        CookieConsentCCTView.prototype.validateContextDataRequest = function () {
            return true;
        };
        CookieConsentCCTView.prototype.getContext = function () {
            return {
                linkTitle: this.settings.custrecord_sc_cookie_consent_cct_linkttl ||
                    'Cookie Settings'
            };
        };
        return CookieConsentCCTView;
    }(CustomContentTypeBaseView));
    exports.CookieConsentCCTView = CookieConsentCCTView;
});
